import styles from './ContactForm.module.sass'
import Image from "next/image";
import {useGameContext} from "@/context/GameContext";
import {createRef, useState} from "react";
import cn from "classnames";
import Input from "@/components/ContactForm/Input";
import Button from "@/components/Button/Button";
import Arrow_SVG from "@/components/svg/Global/Arrow_SVG";
import Link from "next/link";

const ContactForm = () => {

	const {isContactPopupOpen, setIsContactPopupOpen, playAudioOnce} = useGameContext()

	//region Content
	const [sendingState, setSendingState] = useState('')

	const [inputs, setInputs] = useState([
		/*Last name*/
		{
			label: 'Nom',
			ref: createRef(),
			required: true,
			className: styles.last_name,
		},
		/*First name*/
		{
			label: 'Prénom',
			ref: createRef(),
			required: true,
			className: styles.first_name,
		},
		/*Adresse mail*/
		{
			label: 'Mail',
			ref: createRef(),
			required: true,
			className: styles.mail,
		},
	])

	const [messageInput, setMessageInput] = useState({
		label: 'Votre Message',
		ref: createRef(),
		required: true,
		className: styles.message,
	})
	//endregion

	//region Handlers
	const handleSubmit = (event) => {
		playAudioOnce('/sound/button_click.mp3')

		event.stopPropagation()
		event.preventDefault()

		// Set all good
		let allGood = true

		const inputsToCheck = [
			...inputs,
			messageInput
		]

		// Loop through inputs to check if the value is valid
		const data = inputsToCheck.map(input => {
			// Reset error message
			input.errorMessage = ''

			// Get value
			const value = input.ref.current.value

			// Check if the value is valid
			if (input.required && value === '') {
				// Set all good to false
				allGood = false

				// Set error message
				input.errorMessage = 'Ce champ est requis'
			}

			// Set data
			return {
				name: input.label,
				value: value,
			}
		})

		// Reset values
		setInputs([...inputs])
		setMessageInput({...messageInput})

		// If all good
		if (allGood) {
			setSendingState('Envoie en cours...')

			fetch('/api/contact',
					{
						method: 'POST',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(data),
					},
			).then(res => {
				// If success
				if (res.status
						=== 200) {
					setSendingState('Votre message a bien été envoyé !')
				} else {
					setSendingState('Une erreur est survenue lors de l\'envoi de votre message')
				}
			})
					.catch(err => {
						setSendingState('Une erreur est survenue lors de l\'envoi de votre message')
					})
					.finally(() => {
						setTimeout(() => {
							setSendingState('')
						}, 5000)
					})
		}
	}
	//endregion

	return (
			<section className={cn(styles.contact_form__wrapper, {[styles.opened]: isContactPopupOpen})} data-lenis-prevent>
				<div className={styles.contact_form}>
					<div className={styles.content}>
						{/*Close*/}
						<div className={cn(styles.close_btn, 'custom_pointer')} onClick={() => {
							setIsContactPopupOpen(false)
						}}>
							<svg className={styles.close_btn__svg}
							     xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
								<path d="M30 26.7391V3.91304H29.3493V2.6087H28.6986V1.95652H27.3978V1.30435H26.7471V0.652174H26.0964V1.90735e-06H3.90362V0.652174H3.2529V1.30435H2.60217V1.95652H1.30145V2.6087H0.650725V3.91304H0V26.7391H0.650725L0.652174 28.0435H1.30435V28.6957H2.6087V29.3478H3.91304V30H26.087V29.3478H27.3913V28.6957H28.6957V28.0435H29.3478L29.3493 26.7391H30Z"
								      fill="#A8A78A"/>
							</svg>
							<Image className={styles.close_btn__image}
							       src={'/images/ContactForm/close_btn.png'}
							       alt={"Close"}
							       width={10}
							       height={10}
							       quality={100}
							       unoptimized={true}/>
						</div>

						{/*Logo*/}
						<Image className={styles.logo}
						       src={"/Global/logo_full_mobile.png"}
						       alt={"Logo Affectio"}
						       width={512}
						       height={512}
						/>

						{/*Title*/}
						<span className={styles.title}>Contactez-moi</span>

						{/*Form*/}
						<form className={styles.form}>
							{/*Inputs*/}
							{inputs.map((input, index) => (<Input
									key={index}
									type={'text'}
									placeholder={input.label}
									ref={input.ref}
									required={input.required}
									className={input.className}
							/>))}

							{/*Message*/}
							<Input
									inputType={'textarea'}
									placeholder={messageInput.label}
									ref={messageInput.ref}
									required={messageInput.required}
									className={messageInput.className}
							/>

							{/*Submit*/}
							<Button className={styles.submit_btn}
							        type={'submit'}
							        height={'2.5rem'}
							        borderSize={'1px'}
							        gradientPercentage={'85%'}
							        buttonPadding={'.2rem'}
							        onClick={handleSubmit}
							>
								<div className={styles.button_content}>
									<div className={styles.text}>Envoyer</div>
									<Arrow_SVG className={styles.arrow} color={'#0D422E'}/>
								</div>
							</Button>

							{/*Sending state*/}
							{sendingState !== '' && <span className={styles.sending_state}>{sendingState}</span>}
						</form>
					</div>
					{/*Cabinet*/}
					<div className={styles.cabinet}>
						<span className={styles.cabinet__title}>Cabinet Affectio Societatis</span>
						{/*Informations*/}
						<div className={styles.cabinet__informations}>
							<Link href={'mailto:Contact@affectiosocietatis.com'}>Contact@affectiosocietatis.com</Link>
							<Link href={'tel:0473162532'}>04 73 16 25 32</Link>
							<span>10 rue Laënnec</span>
							<span>63100 CLERMONT-FERRAND</span>
						</div>
					</div>
				</div>
			</section>
	)
}
export default ContactForm;